import React from 'react';
import {Button, Form, FormGroup, Label, FormText, Container, Row, Col, Badge} from 'reactstrap';
import axios from 'axios';
import "react-table/react-table.css";
import Calendar from 'react-calendar';
import _ from 'lodash';
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link} from "react-router-dom";
import {connect} from 'react-redux';

import {sendMessage, showMessage, showFirstMessage, retrievePhoto} from "../modules/actions/message";
import '../styles/chat.scss';
import '../styles/profile.scss';
import 'react-chat-elements/dist/main.css';
import Swal from "sweetalert2";

import travellerIcon from '../img/traveller.jpg';


class Message extends React.Component {
    constructor(props) {
        super(props);
        // console.log("this props", this.props.match.params.msgId);
        this.state = {
            messageId: this.props.match.params.msgId,
            senderName: this.props.user.username,
        };
        this.showFirstMessage = this.showFirstMessage.bind(this);
        this.showMessage = this.showMessage.bind(this);
        // this.retrievePhoto = this.retrievePhoto.bind(this);
    }

    componentDidMount() {
        this.showFirstMessage();
        this.showMessage();
        // this.retrievePhoto();
    }

    handleChange(event){
        let values = this.state;
        // console.log('values ', values);
        // console.log(event.target.name);
        values[event.target.name] = event.target.value;
        this.setState(values);
        // console.log(values, "this state is",this.state);
    }

    async sendMessage(){
        let that = this;
        let result = await this.props.dispatch(sendMessage(this.state));
        // console.log("message result", result);
        if(result.status==="Success"){
            Swal.fire({
                title: 'Success!',
                text: 'Your message is sent successfully.',
                type: 'success',
                confirmButtonText: 'close'
            })
                .then(()=>{
                    that.showMessage();
                    console.log("Dismissed");
                    that.setState({message: ''})
                    // that.retrievePhoto();
                    // window.location.assign('/dashboard/message/'+this.state.messageId);
                    // that.setState({}, ()=>{
                    //     that.showMessage();
                    // })
                });
        }

    }

    async showFirstMessage(){
        let payload = {
            "msgId": this.props.match.params.msgId,
        }
        let result = await this.props.dispatch(showFirstMessage(payload));
        // console.log("show first msg", result);
        this.setState({
            firstSenderName: result[0].senderName,
            firstRecipientName: result[0].recipientName,
            firstMsg: result[0].firstMsg,
            firstTimeStamp: result[0].timeStamp,
        });
        // console.log("firstMsg", this.state.firstSenderName);
        if(this.state.firstSenderName === this.props.user.username){
            this.setState({profileOwnerName: this.state.firstRecipientName})
        }else{
            this.setState({profileOwnerName: this.state.firstSenderName})
        }

    }

    async showMessage(){
        let that = this;
        let payload = {
            "messageId": this.state.messageId,
        }
        let result = await this.props.dispatch(showMessage(payload));
        // console.log("show msg", result);
        this.setState({
            messageList : result.message
        });
        // this.state.messageList && this.state.messageList.map((message)=>{
        //     this.retrievePhoto(message.senderName)
        // })

        // console.log("firstMsg", this.state.firstSenderName);
    }

    // async retrievePhoto(senderName){
    //     let that = this;
    //     let payload = {
    //         "username": senderName
    //     }
    //     // let result =
    //         await this.props.dispatch(retrievePhoto(payload))
    //         .then((result)=>{
    //             console.log("check result", result);
    //             that.setState({
    //                 photo2: result.photoUrl
    //             })
    //         });
    //
    //     // console.log("photo result", result.photoUrl);
    //     // this.setState({
    //     //     photoUrl : result.photoUrl
    //     // });
    //     // console.log("photo url", this.state.photoUrl);
    //     // return result.photoUrl
    // }

    render() {
        let firstMsgDate = new Date(this.state.firstTimeStamp*1000);
        let firstMessageDate = firstMsgDate.toLocaleString();
        // console.log("this state", this.state);
        return (
            <div>
                <Row>
                    <Col xs={2}></Col>
                    <Col xs={8}>
                        <div style={{"marginTop": "3rem"}}>
                            <div style={{"width":"100%", "height":"100px", "background-color":"#FF927B", "padding":"20px"}}>
                                <a href={"/dashboard/profile/"+this.state.profileOwnerName}
                                   style={{"color":"black"}}>
                                    ← Go back to {this.state.profileOwnerName}'s profile page
                                </a></div>
                            <form>
                            <textarea
                                name="message" id="message"
                                placeholder="Write a message"
                                style={{ width: '100%', height: '15vh' }}
                                value={this.state.message}
                                onChange={this.handleChange.bind(this)}
                            />
                            </form>
                            <button onClick={this.sendMessage.bind(this)}>Send</button>
                        </div>
                        <br />
                        <br />
                        {/*<Row>*/}
                        {/*    <Col xs="1">*/}
                        {/*        <img src={travellerIcon} className="chat-img"/>*/}
                        {/*    </Col>*/}
                        {/*    <Col xs="10">*/}
                        {/*        <div style={{"font-weight":"bold"}}>*/}
                        {/*            <span>{this.state.firstSenderName}</span>*/}
                        {/*            <span style={{"font-size":"10px"}}>{firstMessageDate}</span></div>*/}
                        {/*        <div>{this.state.firstMsg}</div>*/}
                        {/*        <hr></hr>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}
                        <div>
                            {this.state.messageList && this.state.messageList.map((message)=>{
                                let msgUnix = message.timeStamp;
                                let messageDate = new Date(msgUnix*1000);
                                // retrievePhoto(message.senderName);
                                // console.log("retrieve photo", photo);
                                return(
                                    <Row>
                                        {/*<Col xs="1">*/}
                                        {/*    <img src={this.state.photoUrl ?*/}
                                        {/*        this.state.photoUrl*/}
                                        {/*        :travellerIcon} className="chat-img"/>*/}
                                        {/*</Col>*/}
                                        <Col xs="10">
                                            <div>
                                                <div style={{"font-weight":"bold"}}>
                                                    <span>{message.senderName}</span>
                                                    <span style={{"font-size":"10px"}}>{messageDate.toLocaleString()}</span>
                                                </div>
                                                <div>{message.message}</div>
                                                <hr></hr>
                                            </div>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                        <Row>
                            {/*<Col xs="1">*/}
                            {/*    <img src={travellerIcon} className="chat-img"/>*/}
                            {/*</Col>*/}
                            <Col xs="10">
                                <div style={{"font-weight":"bold"}}>
                                    <span>{this.state.firstSenderName}</span>
                                    <span style={{"font-size":"10px"}}>{firstMessageDate}</span></div>
                                <div>{this.state.firstMsg}</div>
                                <hr></hr>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={2}></Col>
                </Row>

            </div>

        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user,
    };
}


export default withTracker(withRouter(connect(mapStateToProps)(Message)));
